/**
 * Where the carts live.
 *
 * One row per cart in the building. The kind decides everything about how it
 * behaves; this only says where it is parked when a run starts.
 *
 * The table cart in banquet storage is the one the whole ferrying loop was
 * built around. The rest are room service carts, parked where room service
 * carts are parked, and they are identical to it in every way that matters —
 * which is the point. Nothing gives the banquet cart special treatment.
 */
export const WHEELED = [
  { id: 'cart-banquet', kind: 'tablecart', at: [126, -8] },
  { id: 'cart-banquet-2', kind: 'tablecart', at: [150, -8] },
  { id: 'cart-dock', kind: 'tablecart', at: [26, -38] },
  { id: 'cart-service-corridor', kind: 'servicecart', at: [64, 4] },
  { id: 'cart-service-kitchen', kind: 'servicecart', at: [-16, -22] },
  { id: 'cart-service-lobby', kind: 'servicecart', at: [150, 20] },
  { id: 'cart-service-ballroom', kind: 'servicecart', at: [96, 20] },
  /*
   * The hotel's golf cart, for running guests out to the courts. Parked in the
   * staff lot, because the lot's gate opens on the drive and the drive is the
   * top of the cart road.
   * Nothing says it stays outdoors; a four foot dock and a cart that takes a
   * kerb and not a stair says it.
   */
  { id: 'cart-golf', kind: 'golfcart', at: [-40, -72] },
  /*
   * The kitchen's ice cart, parked by the kitchen door out of the Chef's lane.
   * Empty until somebody is short of ice somewhere (`data/deliveries.js`).
   */
  { id: 'cart-ice', kind: 'icecart', at: [-32, -14] },
  /*
   * The lawn's own: a table cart and two chair carts, left out on the Breeze
   * Lawn between the stacks and the north-east gate, side by side, which is
   * where a crew striking a lawn wants them. Pointed north at the gate (`yaw`,
   * a half turn), so either end is a drawbar a golf cart can be backed up to. Pushed by hand
   * they are the same carts as the ones indoors; nothing about them is for
   * towing but where they are.
   */
  { id: 'cart-lawn-tables', kind: 'tablecart', at: [236, 124], yaw: Math.PI },
  { id: 'cart-lawn-chairs-1', kind: 'chaircart', at: [252, 124], yaw: Math.PI },
  { id: 'cart-lawn-chairs-2', kind: 'chaircart', at: [268, 124], yaw: Math.PI },
];

export default WHEELED;
